module.exports = __webpack_public_path__ + "img/tmall-taobao.8aae2b5a.png";